const angular = require('angular');
const moment = require('moment');

class peppolReceptionCtrl {
    /*@ngInject*/
    constructor($state, logger, AuthSvc, $uibModal, CommunitySvc, $scope, PeppolSvc, $window) {
        this.$state = $state;
        this.logger = logger;
        this.AuthSvc = AuthSvc;
        this.$uibModal = $uibModal;
        this.$scope = $scope;
        this.PeppolSvc = PeppolSvc;
        this.$window = $window;
        this.DATE_FORMAT_MASK = 'YYYY-MM-DD';
        this.TIME_MASK = { h: 0, m: 0, s: 0, ms: 0 };
    }

    $onInit() {
        this.peppolTypeIdentifierList = [];
        if (!this.parentForm.peppolIdentifiers) {
            this.parentForm.peppolIdentifiers = this.legalEntity.peppolIdentifiers;
        }
        if (this.legalEntity && this.legalEntity.country) {
            this.PeppolSvc.getPeppolTypeIdentifierByCountry(this.legalEntity.country.code).then(
                data => {
                    this.peppolTypeIdentifierList = data;
                    if (this.canAddRow()) {
                        this.addRow();
                    }
                },
                () => {
                    this.logger.error('error.search');
                }
            );
        }
    }
    // Ajout d’un nouvel identifiant vide
    addRow() {
        this.parentForm.peppolIdentifiers.push({
            identifier: '',
            startDate: moment(this.TIME_MASK).format(this.DATE_FORMAT_MASK),
            readonly: false,
            typeIdentifierId: null,
        });
    }
    // Suppression d’un élément
    removeRow(index) {
        this.parentForm.peppolIdentifiers.splice(index, 1);
    }
    getAvailableIdentifiers(currentIndex) {
        // Récupère les IDs déjà utilisés (toutes lignes sauf celle en cours)
        const usedIds = this.parentForm.peppolIdentifiers
            .filter((row, idx) => row.typeIdentifierId && idx !== currentIndex)
            .map(row => row.typeIdentifierId);

        // Filtre les identifiants non encore utilisés
        return this.peppolTypeIdentifierList.filter(item => !usedIds.includes(item.id));
    }
    //  Vérifie s’il reste des types disponibles pour permettre un ajout
    canAddRow() {
        const totalPossible = this.peppolTypeIdentifierList.length;
        const currentCount = this.parentForm.peppolIdentifiers.length;

        // cas 2 : toutes les lignes déjà atteintes
        const noMoreSlots = currentCount >= totalPossible;

        // on désactive si plus aucun type ou limite totale atteinte
        return !noMoreSlots;
    }
}

angular.module('app.principal').component('peppolReception', {
    templateUrl: require('./peppol-reception.html'),
    controller: peppolReceptionCtrl,
    bindings: {
        legalEntity: '<',
        parentForm: '<',
    },
});
